import { useState, useEffect } from "react";
import API from "../api";
import Select from "react-select";

function Billing() {

  const [orders, setOrders] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [selectedOrders, setSelectedOrders] = useState([]);

  const [billingStatus, setBillingStatus] = useState("PENDING");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");


  /* ================= LOAD CUSTOMERS ================= */

  useEffect(() => {
    API.get("order/get-customers/")
      .then(res => setCustomers(res.data));
  }, []);

  /* ================= FETCH ORDERS ================= */

  const fetchOrders = () => {

    let params = "";

    if (selectedCustomer) {
      params += `customer_id=${selectedCustomer}`;
    }

    if (billingStatus) {
      params += `${params ? "&" : ""}billing_status=${billingStatus}`;
    }

    if (fromDate) {
      params += `${params ? "&" : ""}from_date=${fromDate}`;
    }

    if (toDate) {
      params += `${params ? "&" : ""}to_date=${toDate}`;
    }

    API.get(`order/billing/orders/?${params}`)
      .then(res => {
        setOrders(res.data);
        setSelectedOrders([]);
      });
  };

  /* ================= AUTO FETCH WHEN CUSTOMER CHANGES ================= */

    useEffect(() => {

    if (!selectedCustomer) {
        // 🔥 Clear everything when customer is deselected
        setOrders([]);
        setSelectedOrders([]);
        return;
    }

    const timeout = setTimeout(() => {
        fetchOrders();
    }, 300); // 300ms delay

    return () => clearTimeout(timeout);

    }, [selectedCustomer, billingStatus, fromDate, toDate]);
  /* ================= SELECT ORDER ================= */

  const toggleOrder = (order) => {

    const exists = selectedOrders.find(
      o => o.order_id === order.order_id
    );

    if (exists) {
      setSelectedOrders(
        selectedOrders.filter(
          o => o.order_id !== order.order_id
        )
      );
    } else {
      setSelectedOrders([...selectedOrders, order]);
    }
  };

  /* ================= SELECT ALL ================= */

  const selectAll = () => {

    const pendingOrders = orders.filter(
        order => order.billing_status !== "BILLED"
    );

    const allPendingSelected =
        pendingOrders.length > 0 &&
        pendingOrders.every(order =>
        selectedOrders.some(
            selected => selected.order_id === order.order_id
        )
        );

    if (allPendingSelected) {
        // Unselect only pending orders
        setSelectedOrders(
        selectedOrders.filter(
            order => order.billing_status === "BILLED"
        )
        );
    } else {
        setSelectedOrders(pendingOrders);
    }
    };

  /* ================= SUMMARY ================= */

  const calculateSummary = () => {

    let summary = {};

    selectedOrders.forEach(order => {
      order.items.forEach(item => {

        if (!summary[item.sheet_id]) {
          summary[item.sheet_id] = {
            name: item.sheet_name,
            quantity: 0,
            price: item.price
          };
        }

        summary[item.sheet_id].quantity += item.quantity;
      });
    });

    return Object.values(summary);
  };

  const summary = calculateSummary();

  const grandTotal = summary.reduce(
    (sum, item) => sum + item.quantity * item.price,
    0
  );

  /* ================= GENERATE BILL ================= */

  const generateBill = async () => {

    if (selectedOrders.length === 0) {
      alert("Please select orders first");
      return;
    }

    await API.post("order/billing/mark-billed/", {
      order_ids: selectedOrders.map(o => o.order_id)
    });

    alert("Bill generated successfully");

    setSelectedOrders([]);
    fetchOrders();
  };

  /* ================= UI ================= */
  const copyBillToWhatsApp = () => {

    if (selectedOrders.length === 0) {
        alert("Select orders first");
        return;
    }

    const customer = customers.find(
        c => c.id === selectedCustomer
    );

    if (!customer?.mobile_number) {
        alert("Customer mobile number not available");
        return;
    }

    // Remove + and spaces just in case
    const mobileNumber = customer.mobile_number
    console.log("Customer Mobile Number:", mobileNumber);

    let message = "🧾 *BILL SUMMARY*\n\n";
    message += `Customer: ${customer.name}\n\n`;
    message += "━━━━━━━━━━━━━━━━━━\n\n";
    message += "CF = \n"; 

    summary.forEach((item, index) => {
        const total = item.quantity * item.price;

        message += `${index + 1}) ${item.name}\n`;
        message += `Qty: ${item.quantity} × ₹${item.price} = ₹${total}\n\n`;
    });

    message += "━━━━━━━━━━━━━━━━━━\n";
    message += `*Grand Total: ₹${grandTotal}*\n\n`;

    const encodedMessage = encodeURIComponent(message);

    // ✅ Open WhatsApp with mobile number
    window.open(
        `https://wa.me/${mobileNumber}?text=${encodedMessage}`,
        "_blank"
    );
    };
  return (
  <div className="container-fluid py-3">
    <div className="row">

      {/* ================= LEFT SIDE ================= */}
      <div className="col-12 col-lg-8 mb-4">
        <div className="bg-white p-3 rounded shadow-sm">

          {/* HEADER + FILTER */}
          <div
            className="border-bottom pb-3 mb-3"
            style={{ position: "sticky", top: 0, background: "#fff", zIndex: 10 }}
          >
            <h5 className="mb-3">Billing</h5>

            {/* CUSTOMER FILTER */}
            <div className="mb-3" style={{ maxWidth: "300px" }}>
              <Select
                options={customers.map(c => ({
                  value: c.id,
                  label: c.name
                }))}
                onChange={(selected) =>
                  setSelectedCustomer(selected ? selected.value : "")
                }
                placeholder="Select Customer..."
                isClearable
              />
            </div>

            {selectedCustomer && (
              <>
                <div className="row g-2 mb-3">
                  <div className="col-12 col-md-4">
                    <select
                      className="form-select"
                      value={billingStatus}
                      onChange={(e) => setBillingStatus(e.target.value)}
                    >
                      <option value="">All</option>
                      <option value="PENDING">Pending</option>
                      <option value="BILLED">Billed</option>
                    </select>
                  </div>

                  <div className="col-6 col-md-4">
                    <input
                      type="date"
                      className="form-control"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                    />
                  </div>

                  <div className="col-6 col-md-4">
                    <input
                      type="date"
                      className="form-control"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                    />
                  </div>
                </div>

                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={selectAll}
                >
                  Select All (Pending Only)
                </button>
              </>
            )}
          </div>

          {/* ORDER LIST */}
          <div style={{ maxHeight: "65vh", overflowY: "auto" }}>
            {orders.map(order => (
              <div key={order.order_id} className="card mb-2">

                <div className="card-header d-flex justify-content-between align-items-center flex-wrap">

                  <div className="mb-2 mb-md-0">
                    <strong>{order.order_code}</strong>

                    <span
                      className={`badge ms-2 ${
                        order.billing_status === "BILLED"
                          ? "bg-success"
                          : "bg-warning"
                      }`}
                    >
                      {order.billing_status}
                    </span>

                    <span className="text-muted ms-2 small">
                      {order.order_date}
                    </span>
                  </div>

                  <input
                    type="checkbox"
                    checked={selectedOrders.some(
                      o => o.order_id === order.order_id
                    )}
                    onChange={() => toggleOrder(order)}
                    disabled={order.billing_status === "BILLED"}
                  />

                </div>

                <div className="card-body p-2 table-responsive">
                  <table className="table table-sm mb-0">
                    <thead>
                      <tr>
                        <th>Sheet</th>
                        <th>Qty</th>
                        <th>Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      {order.items.map((item, i) => (
                        <tr key={i}>
                          <td>{item.sheet_name}</td>
                          <td>{item.quantity}</td>
                          <td>₹ {item.price}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

              </div>
            ))}
          </div>

        </div>
      </div>

      {/* ================= RIGHT SIDE SUMMARY ================= */}
      <div className="col-12 col-lg-4">
        <div
          className="bg-white p-3 rounded shadow-sm"
          style={{ position: "sticky", top: "20px" }}
        >
          <h5>Bill Summary</h5>

          {summary.length === 0 && (
            <div className="text-muted">
              Select orders to generate bill
            </div>
          )}

          {summary.length > 0 && (
            <>
              <div className="table-responsive">
                <table className="table table-sm">
                  <thead>
                    <tr>
                      <th>Product</th>
                      <th>Qty</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {summary.map((item, index) => (
                      <tr key={index}>
                        <td>{item.name}</td>
                        <td>{item.quantity}</td>
                        <td>₹ {item.quantity * item.price}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <hr />

              <h6>Grand Total: ₹ {grandTotal}</h6>

              <button
                className="btn btn-primary w-100 mt-3"
                onClick={generateBill}
              >
                Generate Bill
              </button>

              <button
                className="btn btn-success w-100 mt-2"
                onClick={copyBillToWhatsApp}
              >
                Copy Bill for WhatsApp
              </button>
            </>
          )}
        </div>
      </div>

    </div>
  </div>
);
}

export default Billing;